module.exports = __webpack_public_path__ + "static/img/ic_login_bg_1.6b37d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_login_bg_1.jpg
// module id = FHn/
// module chunks = 10 13